import { datadogRum } from '@datadog/browser-rum'
import { MyUser, MyActiveOrganization } from '@/helpers/my-account-helper'
export const nodeProdEnv = 'production'
export const datadogEnabledEnvs = ['prod', 'demo', 'qa', 'staging']

export function initDatadog(env) {
  const environment = env || window.$appConfig.VUE_APP_ENVIRONMENT_SLUG

  if (window.$appConfig.NODE_ENV !== nodeProdEnv || !_.includes(datadogEnabledEnvs, environment)) {
    return
  }

  datadogRum.init({
    applicationId: window.$appConfig.VUE_APP_DDOG_RUM_APPLICATION_ID,
    clientToken: window.$appConfig.VUE_APP_DDOG_RUM_CLIENT_TOKEN,
    site: window.$appConfig.VUE_APP_DDOG_RUM_SITE,
    service: window.$appConfig.VUE_APP_DDOG_RUM_SERVICE,
    env: environment,
    version: process.env.VERSION,
    sampleRate: 100,
    trackInteractions: true,
    beforeSend: () => {
      // update viewport size on event send (dd doesn't allow modification of view event contexts)
      datadogRum.addRumGlobalContext('viewport', {
        width: window.innerWidth,
        height: window.innerHeight
      })
      datadogRum.setUser({
        id: MyUser.id,
        email: MyUser.email,
        name: MyUser.username,
        active_organization_id: MyActiveOrganization.id,
        active_organization_name: MyActiveOrganization.name
      })
    }
  })

  datadogRum.addRumGlobalContext('environment.name', environment)
  datadogRum.addRumGlobalContext('application_version', process.env.VERSION)
}
